<template>
	<el-dialog :visible.sync="isVisible" title="Tecnicos">
		<div class="elements-wrap">
			<SelectTechnicianTableReact
				:technicians="technicians"
				:loading="isLoading"
				:buttonsText="buttonsText"
				:onSelect="onSelectHandler"
			/>
		</div>
	</el-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { SelectTechnicianTable } from "@/components/technician/SelectTechnicianTable";
import { ETechnicianActions } from "../../modules/technician/services/store/technician/technician.types";
import type { ITechnician } from "../../modules/technician/types/technician.interface";

const SelectTechnicianTableReact = ReactInVue(SelectTechnicianTable);

export default Vue.extend({
	name: "SelectTechnicianModal",
	components: {
		SelectTechnicianTableReact,
	},

	props: {
		visibility: {
			type: Boolean,
			default: false,
		},
		buttonsText: {
			type: String,
			default: "Selecionar",
		},
	},

	data() {
		return {
			isVisible: false,
		};
	},

	computed: {
		technicians(): Array<ITechnician> {
			return this.$store.get("technician/technicians");
		},

		isLoading(): boolean {
			return this.$store.get("technician/loading");
		},
	},

	watch: {
		visibility(newVal, oldVal) {
			// prevent infinity loops
			if (newVal === oldVal) {
				return;
			}

			this.isVisible = newVal;
		},

		isVisible(newVal) {
			const notInSync = this.visibility !== newVal;
			// update the outside world if needed
			if (notInSync) {
				this.$emit("update:visibility", newVal);
			}

			// emit a dismiss event when the user doesn't select a technician
			if (notInSync && !newVal) {
				this.$emit("dismiss");
			}
		},
	},

	async created() {
		await this.$store.dispatch(ETechnicianActions.FETCH_ALL);
	},

	methods: {
		onSelectHandler(technician: ITechnician) {
			this.isVisible = false;
			this.$emit("selected", technician);
		},
	},
});
</script>

<style lang="scss" scoped>
.elements-wrap {
	display: flex;
}

.selectElement {
	display: block;
	width: 100%;
}

.selecteButton {
	margin-left: 10px;
}
</style>
